import { useConferenceStore } from '@/stores/conference.store';
import { useVoipStore } from '@/stores/voip.store';
import { conferenceApi } from './api';

/**
 * Hang up an internal call the way a phone does: the window closes straight
 * away instead of waiting on the service, the room is ended for everyone
 * (including teammates still ringing), and this tab's own leg is dropped.
 *
 * If the end request fails, dropping our leg still ends the room — the service
 * tears a room down when a host who joined it hangs up — so there is nothing
 * left on screen to report the failure against.
 */
export function endTeamCall(conferenceId: string) {
  useConferenceStore.getState().close();
  void conferenceApi.end(conferenceId).catch(() => undefined);
  useVoipStore.getState().hangupConferenceLegs();
}
